import { html } from "lit";
import { unsafeHTML } from "../../node_modules/lit/directives/unsafe-html.js";

import '../parts/card';
import '../parts/monster';
import '../parts/event';
import '../parts/status';
import { enumValue } from "./utils.js";
import { CONDITION_OPERATOR, CONDITION_VALUE, GAME_TRIGGERS } from "./types.js";

export const CARD_TYPE = [
    'Melee',
    'Magic',
    'Ranged',
    '',
    'Divine',
    'Move',
    'Corruption',
    'Monster',
    ''
];

export const CARD_CATEGORY = [
    'Action',
    'Item',
    'Artifact',
    'Conjuration',
    'Enchantment',
    'Basic Attack',
    'Summon',
    'Performance',
    'Form',
    'Hymn',
    'Talent',
    'Revelation',
    'Affix',
    'Attunement',
    'Equipment',
    'Code',
    'Ingredient',
    'Path',
    'Location',
    'Offering'
];

export function parseHTML(html_, inline_) {
    const check = new RegExp('\\[(.*?)\\=(.*?)\\]', 'g');
    const matches = (html_ || '').match(check);
    if (matches) {
        for (let i = 0; i < matches.length; i++) {
            let type = matches[i].replace(check, '$1');
            const talent = (type === 'talent');
            if (talent)
                type = 'card';
            let id = matches[i].replace(check, '$2');
            html_ = html_.replace(`[${talent ? 'talent' : type}=${id}]`, `<${type}-part id="${id}" ${inline_ ? 'inline="true"' : ''} ${talent ? 'talent="true"' : ''}></${type}-part>`);
        }
    }
    return html`
        ${unsafeHTML(html_.replace(/\n/g, '<br>'))}
    `;
}

export function processDesc(desc) {

    desc = desc || '';
    desc = desc
        .replace(/<b>/g, '')
        .replace(/<\/b>/g, '')
        .replace(/<B>/g, '')
        .replace(/<\/B>/g, '')
        .replace(/<nobr>/g, '')
        .replace(/<\/nobr>/g, '');

    desc = desc.replace(/DEX/g, `<img loading="lazy" class="cost-small" src="./images/dex.webp" alt="dex" />`);
    desc = desc.replace(/STR/g, `<img loading="lazy" class="cost-small" src="./images/str.webp" alt="str" />`);
    desc = desc.replace(/INT/g, `<img loading="lazy" class="cost-small" src="./images/int.webp" alt="int" />`);
    desc = desc.replace(/HOLY/g, `<img loading="lazy" class="cost-small" src="./images/holy.webp" alt="holy" />`);
    desc = desc.replace(/BLOOD/g, `<img loading="lazy" class="cost-small" src="./images/blood.webp" alt="blood" />`);
    desc = desc.replace(/HEALTH/g, `<img loading="lazy" class="cost-small" src="./images/health.webp" alt="health" />`);
    return desc
}

export function addCost(card, type) {
    let costs = [];
    if(card.cost){
        for (let i = 0; i < card.cost[type]; i++)
            costs.push(1);
    }
    if (costs.length <= 0)
        return '';
    return html`
        ${costs.map(() => html`<img loading="lazy" class="cost" src="./images/${type}.webp" title=${type} alt=${type} />`)}
    `;
}

export function processEffect(eff, changelog, del) {
    return html`
        <div class="bubble big effect" style="${changelog ? `font-size:12px;background-color:${del ? '#543131' : '#2c552a'};` : ''}">
            <div style="vertical-align:middle;">
            ${eff.type ? html`<b style="color:#ccc">${eff.type}${eff.desc ? ':' : ''}</b> ${unsafeHTML(processDesc(eff.desc))}` : eff.codeLine} ${eff.status ? html`<status-part id=${eff.status} inline="true"></status-part>` : ''} ${eff.card && eff.cards?.length === 0 ? html`<card-part id=${eff.card} inline="true"></card-part>` : ''} ${eff.cards?.length > 0 ? html`
            ${eff.cards.map((c, i) => html`${i > 0 ? ' | ' : ''}<card-part id=${c} inline="true"></card-part> `)}
            ` : ''} 
            <small>
            ${eff.trigger ? 'when ' : ''}<span class="flavor" style="display:inline;">${enumValue(GAME_TRIGGERS, eff.trigger)}</span>
            ${eff.conditions?.map(cond => html`
                and <span class="flavor" style="display:inline;">${cond.targetValue}</span> ${enumValue(CONDITION_OPERATOR, cond.conditonOperator)} <span class="flavor" style="display:inline;">${enumValue(CONDITION_VALUE, cond.valueToCheck)}</span>
            `)}
            </div>
            </small>
        </div>
    `;
}

export function processLog(l) {
    if (l.indexOf('desc') === 0)
        return html`<li><span class="type">description:</span> ${unsafeHTML(processDesc(l.substr(13)))}</li>`;
    if (l.indexOf('rarity') === 0) {
        const rarity = ['Common', 'Uncommon', 'Rare', 'Legendary', 'Monster', 'Epic', 'Mythic', 'Ultra'];
        const check = new RegExp(/(\d+)/, 'g');
        const matches = (l || '').match(check);
        if (matches) {
            for (let i = 0; i < matches.length; i++) {
                let val = matches[i].replace(check, '$1');
                l = l.replace(val, rarity[+val]);
            }
        }
    }
    if (l.indexOf('category') === 0) {
        const check = new RegExp(/(\d+)/, 'g');
        const matches = (l || '').match(check);
        if (matches) {
            for (let i = 0; i < matches.length; i++) {
                let val = matches[i].replace(check, '$1');
                l = l.replace(val, CARD_CATEGORY[+val]);
            }
        }
    }
    if (l.indexOf('type') === 0) {
        const check = new RegExp(/(\d+)/, 'g');
        const matches = (l || '').match(check);
        if (matches) {
            for (let i = 0; i < matches.length; i++) {
                let val = matches[i].replace(check, '$1');
                l = l.replace(val, CARD_TYPE[+val]);
            }
        }
    }
    if (l.indexOf('cost') === 0) {
        let card = {
            cost: JSON.parse(l.substr(6))
        };
        return html`<li><span class="type">cost:</span> ${addCost(card, 'dex')}${addCost(card, 'dexint')}${addCost(card, 'dexstr')}${addCost(card, 'int')}${addCost(card, 'intstr')}${addCost(card, 'str')}${addCost(card, 'holy')}${addCost(card, 'blood')}${addCost(card, 'neutral')}</li>`;
    }
    if (l.indexOf('oldcost') === 0) {
        let card = {
            cost: JSON.parse(l.substr(9))
        };
        return html`<li><span class="type">oldcost:</span> <del>${addCost(card, 'dex')}${addCost(card, 'dexint')}${addCost(card, 'dexstr')}${addCost(card, 'int')}${addCost(card, 'intstr')}${addCost(card, 'str')}${addCost(card, 'holy')}${addCost(card, 'blood')}${addCost(card, 'neutral')}</del></li>`;
    }
    if (l.indexOf('effects') === 0) {
        let effects = JSON.parse(l.substr(9));
        return html`
            ${effects.length > 0 ? html`<li><span class="type">effects:</span><br>
            ${effects.map(eff => {
            return processEffect(eff, true);
        })}
            </li>`: ''}            
        `;
    }
    if (l.indexOf('enchants') === 0) {
        let enchants = JSON.parse(l.substr(9));
        return html`
            ${enchants.length > 0 ? html`<li><span class="type">enchants:</span><br>
            ${enchants.map(eff => {
            return processEffect(eff, true);
        })}
            </li>`: ''}
        `;
    }
    if (l.indexOf('oldeffects') === 0) {
        let effects = JSON.parse(l.substr(12));
        return html`
            ${effects.length > 0 ? html`<li><span class="type">oldeffects:</span><br>
            ${effects.map(eff => {
            return processEffect(eff, true, true);
        })}
            </li>`: ''}
        `;
    }
    if (l.indexOf('oldenchants') === 0) {
        let enchants = JSON.parse(l.substr(12));
        return html`
            ${enchants.length > 0 ? html`<li><span class="type">oldenchants:</span><br>
            ${enchants.map(eff => {
            return processEffect(eff, true, true);
        })}
            </li>`: ''}
        `;
    }
    let linepart = l.split(': ');
    return html`<li><span class="type">${linepart[0]}</span>: ${unsafeHTML(linepart[1])}</li>`;
}